import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
  loading: false,
  fuelCards: [],
  total: 0,
  error: null
};

const route = "modules/manage/views/main/components/fuelCardTab/redux/slice.";

export const manageSearchFuelCards = createAsyncThunk(
  "manage/fuelCardTab/manageSearchFuelCards",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchFuelCards.query,
        {
          conditions,
          sort,
          limit,
          offset
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchFuelCards");
      return rejectWithValue(exc);
    }
  }
);

manageSearchFuelCards.query = `
           query ($conditions: [FuelCardSearchInput], $sort: [FuelCardSortInput], $limit: Int, $offset: Int) {
                data: searchFuelCards (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        companyId
                        unitId
                        driverId
                        cardNumber
                        vehicleId
                        vehicleDescription
                        unit {
                            id
                            label
                            tankSize
                        }
                        driver {
                            name
                            contactInfo
                            companyId
                            driverId
                        }
                    }
                    total
                }
            }
          `;

//Slice
const manageFuelCardTabRedux = createSlice({
  name: "manage/fuelCardTab",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchFuelCards
    builder.addCase(manageSearchFuelCards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchFuelCards.fulfilled, (state, action) => {
      state.loading = false;
      state.fuelCards = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchFuelCards.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageFuelCardTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
